define('Winering.ItemRelations.Correlated.View', [
    'ItemRelations.Correlated.View',
    'underscore',
    'SC.Configuration'
], function WineringItemRelationsCorrelatedView(
    ItemRelationsCorrelatedView,
    _,
    Configuration
) {
    'use strict';

    _.extend(ItemRelationsCorrelatedView.prototype, {
        getContext: _.wrap(ItemRelationsCorrelatedView.prototype.getContext, function getContext(fn) {
            var orignalContext = fn.apply(this, _.toArray(arguments).slice(1));
            var pdp = this.options && this.options.application && this.options.application.getComponent('PDP');
            var itemInfo = pdp && pdp.getItemInfo();
            var wineringClasses = Configuration.get('wineRing.classes');
            var classesSeparated;
            var isWineringClass;
            if (wineringClasses) {
                classesSeparated = wineringClasses.split(',');
                isWineringClass = classesSeparated && classesSeparated.indexOf(itemInfo.item.class) < 0;
            }
            orignalContext.showCells = orignalContext.showCells && isWineringClass;
            return orignalContext;
        })
    });
});
